import React, {useEffect, useState, useRef} from "react";
import moment from "moment";
import {NavLink} from "../../../lib/Navigation";
import {Link} from "react-router-dom";
import {useSize} from "ahooks";
import {QuestionCircleOutlined, SyncOutlined} from "@ant-design/icons";
import Dialog from "../../../lib/Dialog";
import {CopyToClipboard} from "react-copy-to-clipboard/lib/Component";

const types = {
  0: '其它',
  2: '攻略',
  3: '独家永久',
  4: '独家限时',
  5: '永久活动',
  6: '限时活动'
};

const status = {
  0: '未开始',
  1: '进行中',
  2: '已结束',
};

export default ({game, setGift, setGiftShow, giftReceive, setShow, giftShowNewWindow}) => {
  const [router, setRouter] = useState(0);
  const [gifts, setGifts] = useState([]);
  const [czb, setCzb] = useState([]);
  const [vipGift, setVipGift] = useState([]);
  // const [voucher, setVoucher] = useState(!!voucherState || true);
  useEffect(() => {
    if (game.gift_bag_list) {
      setCzb(game.gift_bag_list?.filter(gift => (
        parseInt(gift.recharge_amount) > 0)
      ));
      setVipGift(game.gift_bag_list?.filter(gift => (
        gift.vip_level > 0)
      ));
      setGifts(game.gift_bag_list?.filter(gift => (
              (router === 0 && parseInt(gift.recharge_amount) === 0 && gift.vip_level == '')
              || (router === 1 && parseInt(gift.recharge_amount) > 0 && gift.vip_level == '')
              || (router === 2 && gift.vip_level > 0)
              )
              
          )
      );
    }
  }, [game, router]);
  // console.log(game.activity_list.length);

  // console.log(game.gift_bag_list);

  // console.log(gifts[0]);
  const [activeMoreState, setActiveMoreState] = useState(false);
  const [giftMoreState, setGiftMoreState] = useState(false);

  const [rebateMore, setRebateMore] = useState(true);
  const [rebateMored, setRebateMored] = useState(false);
  const rebateBodyRef = useRef();
  const rebateEntityRef = useRef();
  const rebateBodySize = useSize(rebateBodyRef);
  const rebateEntitySize = useSize(rebateEntityRef);
  useEffect(() => {
    if(rebateEntitySize.height && rebateBodySize.height) {
      !rebateMored && setRebateMore(rebateEntitySize.height > rebateBodySize.height);
    }
  }, [rebateBodySize, rebateEntitySize]);

  // console.log(czb.length);

  const [teseState, setTeseState] = useState(false);
  useEffect(() => {
    if(game.game_feature_list) {
      // console.log(game.game_feature_list[0].content);
      if(game.game_feature_list[1].content.trim()) {
        setTeseState(true);
      }
    }
  }, [game.game_feature_list]);

  return <div><div className="game-gift">
    <div className="voucher"  onClick={() => {
          if (game.game_species_type != 1 && !game.voucherslist?.length) {
            return;
          }
          setShow(true);
        }}>
      <div className="voucher-main">
      {/* {game.voucherslist?[game.voucherslist[0], game.voucherslist[1], game.voucherslist[2]].map(voucher => voucher ? <div className={"item " + (voucher.is_received == '0' ? voucher.vip_level ? voucher.vip_level > 0 ? "vip-item" : "" : "" : "") } style={{backgroundImage: voucher.is_received != '0' ? ('url(/resources/game/claimed.png)') : ( voucher.vip_level ? voucher.vip_level >0 ? ('url(/resources/game/vip-unclaimed.png)') : ('url(/resources/game/unclaimed.png)') : ('url(/resources/game/unclaimed.png)'))  }}> */}
      {game.voucherslist?[game.voucherslist[0], game.voucherslist[1], game.voucherslist[2]].map(voucher => voucher ? 
        <div className={"item " + (voucher.is_received == '0' ? voucher.vip_level ? voucher.vip_level > 0 ? "vip-item" : "" : "" : "") } style={{backgroundImage: voucher.is_received != '0' ? (voucher.vip_level ? voucher.vip_level > 0 ? ('url(/resources/game/vip-claimed.png)') : ('url(/resources/game/claimed.png)') : ('url(/resources/game/claimed.png)')) :  ( voucher.vip_level ? voucher.vip_level > 0 ? ('url(/resources/game/vip-unclaimed.png)') : ('url(/resources/game/unclaimed.png)') : ('url(/resources/game/unclaimed.png)'))  }}>
        <div className={"amounts " + (voucher.vip_level ? voucher.vip_level > 0 ? 'vip-amounts' : '' : '')} >
          <div className="amount">
            <span>￥</span><span className="num">{voucher.amount * 1}</span><span>.00</span>
          </div>
          <div className="amount-meet">
          {(() => {
            let meet_amount = voucher.meet_amount * 1;
            if(meet_amount === 0) {
              return '任意金额可用';
            } else {
              return '满' + meet_amount + '元可用';
            }
          })()}
            {/* 满{voucher.meet_amount * 1}元可用 */}
          </div>
        </div>
        <div className={"operate " +  (voucher.vip_level ? voucher.vip_level > 0 ? 'vip-operate' : '' : '')}>{(()=>{
          if(voucher.is_received != '0') {
            return '已领取';
          } else {
            return '领取';
          }
        })()}</div>
        
      </div> : null):null}
      </div>
      {game.voucherslist.length >0 ? <div className="more"><img src="/resources/welfare/left-back.png" className="left-back"/></div> : null}
    </div>
    {game.activity_list.length > 0 ?
    <div className="active-list">
      <div className="head">
        <div className="items clearfix">
          <div className="item text">活动攻略</div>
        </div>
        <NavLink to={"/game/article?id=" + game.game_id} user={false} className="operate">查看更多 <img src="/resources/welfare/left-back.png" className="left-back"/></NavLink>
      </div>
      <div className={"active-main " + (activeMoreState? "data-more":'')}>
        {game.activity_list?.map((article, index) => <Link to={'/article/detail?id=' + article.news_id} className={"item " + (activeMoreState ? '' : (index > 2 ? 'item-display' : null))}>
        <div className="container">
          <div className="desc">
            <div className={'type type-' + article.type}>{types[article.type]}</div>
            <div className="state">{article.status_title}</div>
            <div className="time">{moment(article.news_date * 1000).format('YYYY-MM-DD')}</div>
          </div>
          <div className="title">{article.news_title}</div>
        </div>
        <div className="more">
          <img src="/resources/welfare/left-back.png" className="left-back"/>
        </div>
      </Link>)}
      </div>
      {
        game.activity_list.length > 3 ? (
          activeMoreState ? <div className="select-all" onClick={()=>setActiveMoreState(false)}>收起</div> :
          <div className="select-all" onClick={()=>setActiveMoreState(true)}>查看全部</div>
        )
        :null
      }
    </div>
    :null}
    <div className="gift-list">
      <div className="head">
        <div className="items clearfix">
          <div className={'item ' + (router == 0 ? 'active' : '')} onClick={() => setRouter(0)}>免费礼包</div>
          {
            czb.length > 0 ? 
            <div className={'item ' + (router == 1 ? 'active' : '')} onClick={() => setRouter(1)}>充值礼包</div>
            : null
          }
          {
            vipGift.length > 0 ?
            <div className={'item ' + (router == 2 ? 'active' : '')} onClick={() => setRouter(2)}>会员礼包</div>
            : null
          }
        </div>
        <NavLink to="/user/gift" className="operate">我的礼包<img src="/resources/welfare/left-back.png" className="left-back"/></NavLink>
      </div>
      <div className={"body " + (giftMoreState ? "data-more" : "")}>
        {gifts.length === 0 ? <div className="empty"><img src="/resources/empty.png" alt=""/>暂无</div> : null}
        {gifts.map((gift, index) => <div className={"item " + (giftMoreState?'':(index > 2 ? 'item-display' : null))} onClick={() => {
          // setGift(gift);
          // setGiftShow(true);

          // giftShowNewWindow(gift);
        }}>
          <div className="info">
            <div className="name">
              {gift.packname}
              {gift.vip_level > 0 ? 
                <div className="">
                  {/* <img src="/resources/game/vip-exclusive-new.png" className="exclusive"/>  */}
                  <div className="exclusive-new" style={{backgroundImage:'url(/resources/game/vip-exclusive-new.png)'}}>
                    {gift.vip_level_desc}
                  </div>
                </div>
              : null}
            </div>
            <div className="desc">
              {gift.packcontent}
              <br/>
              有效期：{moment(gift.starttime * 1000).format('YYYY-MM-DD')} 至 {moment(gift.endtime * 1000).format('YYYY-MM-DD')}
            </div>
          </div>
          {gift.is_received ? 
            <CopyToClipboard className="operate" text={gift.pack_card} onCopy={() => Dialog.info('已复制')}>
              <div>复制</div>
            </CopyToClipboard>
          :
            <NavLink className="operate" onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              giftShowNewWindow(gift);
              // setGift(gift);
              // setGiftShow(true);
              // giftReceive(gift);
            }}>领取</NavLink>
          }
        </div>)}
      </div>
      {
        gifts.length > 3 ? (
          giftMoreState ? <div className="select-all" onClick={()=>setGiftMoreState(false)}>收起</div> :
          <div className="select-all" onClick={()=>setGiftMoreState(true)}>查看全部</div>
        )
        :null
      }
    </div>
    
    {/**返利 */}
    <div className="game-explain gift-rebate">
      {game.game_feature_list && game.game_feature_list[1].content && teseState ? <div className="item">
        <div className="head">
          <div className="subject">
            <div className="title">返利</div>
            {game.allow_rebate ? <>
              <div className="info">手动返利</div>
              <div className="tips" onClick={() => Dialog.alert('温馨提示', '充值达到返利标准后，需要通过app手动申请返利，提交审核后24小时内到账！')}><QuestionCircleOutlined/></div>
            </> : <>
              <div className="info">自动返利</div>
              <div className="tips" onClick={() => Dialog.alert('温馨提示', '充值达到返利标准后，无需手动申请，游戏一般为次日0点会自动到账！')}><QuestionCircleOutlined/></div>
            </>}
          </div>
          {game.allow_rebate ? <NavLink to={'/rebate?id=' + game.game_id} className="operate">申请返利></NavLink> : null}
        </div>
        <div className={'body ' + (rebateMored ? 'more' : '')} ref={rebateBodyRef}>
          {/* <div className="entity" ref={rebateEntityRef} dangerouslySetInnerHTML={{__html: game.game_feature_list ? game.game_feature_list[1].content.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2') : null}}/> */}
          <div className="entity" ref={rebateEntityRef} dangerouslySetInnerHTML={{__html: game.game_feature_list ? game.game_feature_list[1].content.replace(/([^>\r\n\r\n]?)(\r\n\r\n|\n\r|\r|\n)/g, '$1<br>$2') : null}}/>
          {rebateMore
              ? <div className={'more ' + (rebateMored ? 'ed' : '')} onClick={() => setRebateMored(!rebateMored)}/>
              : null}
        </div>
      </div> : null}
    </div>
    
  </div>
  </div>;
};